import { call, put, takeEvery, CallEffect, PutEffect } from 'redux-saga/effects';
import { LOGIN_REQUEST, GET_CURRENT_USER_REQUEST } from './Auth.constant';
import {
  loginSuccess,
  loginFailure,
  getCurrentUserSuccess,
  getCurrentUserFailure,
} from './Auth.action';
import { authApi, TokenResponse, UserResponse } from '../../services/auth';
import { ErrorResponseType, HttpStatus } from '../../entities/common';

function* loginSaga(action: { type: string; payload: { username: string; password: string } }): Generator<CallEffect<TokenResponse> | PutEffect, void, TokenResponse> {
  try {
    const { username, password } = action.payload;
    const response = yield call(authApi.login, { username, password });
    
    localStorage.setItem('access_token', response.access_token);
    
    yield put(loginSuccess(response.access_token));
    
    yield put({ type: GET_CURRENT_USER_REQUEST });
  } catch (error: any) {
    const errorResponse: ErrorResponseType = {
      code: error.response?.data?.code || 'TOKEN_VERIFY',
      message: error.response?.data?.message || error.message || 'Authorization error',
      status: error.response?.status || HttpStatus.InternalServerError,
      errors: error.response?.data?.errors || {},
    };
    yield put(loginFailure(errorResponse));
  }
}

function* getCurrentUserSaga(): Generator<CallEffect<UserResponse> | PutEffect, void, UserResponse> {
  try {
    const user = yield call(authApi.getCurrentUser);
    yield put(getCurrentUserSuccess(user));
  } catch (error: any) {
    const errorResponse: ErrorResponseType = {
      code: error.response?.data?.code || 'TOKEN_VERIFY',
      message: error.response?.data?.message || error.message || 'Error getting user data',
      status: error.response?.status || HttpStatus.InternalServerError,
      errors: error.response?.data?.errors || {},
    };
    yield put(getCurrentUserFailure(errorResponse));
    
    if (error.response?.status === HttpStatus.Unauthorized) {
      localStorage.removeItem('access_token');
    }
  }
}

export function* authSaga() {
  yield takeEvery(LOGIN_REQUEST, loginSaga);
  yield takeEvery(GET_CURRENT_USER_REQUEST, getCurrentUserSaga);
}
